import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginView from '../views/LoginView';
import DashboardView from '../views/DashboardView';
import ProtectedRoute from './ProtectedRoute';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginView />} />
      <Route 
        path="/dashboard/*" 
        element={
          <ProtectedRoute>
            <DashboardView />
          </ProtectedRoute>
        } 
      />
      {/* The wildcard in the path above will match all sub-routes */}
    </Routes>
  );
};

export default AdminRoutes; 